<template>
    <v-dialog
        v-model="dialog"
        :max-width="maxWidth"
        :style="{ zIndex: zIndex }"
        @keydown.esc="cancel"
        v-if="customer"
    >
        <v-card>
            <v-card-title class="headline">
                {{ $t('actions.customer.cancellationRequisition.title') }}
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <p>
                    {{
                        $t(
                            'resources.cancellationRequisition.hints.adminRequest',
                        )
                    }}
                </p>
                <p>
                    <strong
                        >{{
                            $t(
                                'resources.cancellationRequisition.attributes.customer',
                            )
                        }}: </strong
                    >{{ customer.legal_name || customer.trade_name }}
                </p>
                <v-text-field
                    :label="
                        $t(
                            'resources.cancellationRequisition.attributes.reason',
                        )
                    "
                    v-model="reason"
                    :counter="255"
                    @input="$v.reason.$touch()"
                    @blur="$v.reason.$touch()"
                    :error-messages="reasonErrors"
                >
                </v-text-field>
            </v-card-text>

            <v-card-actions>
                <v-btn
                    class="col"
                    color="green darken-1"
                    text
                    @click.native="cancel"
                >
                    {{
                        $t(
                            'actions.customer.cancellationRequisitionLimitDay.decline',
                        )
                    }}
                </v-btn>
                <v-divider vertical=""></v-divider>
                <v-btn
                    class="col"
                    color="red darken-1"
                    text
                    @click.native="agree"
                >
                    {{
                        $t(
                            'actions.customer.cancellationRequisitionLimitDay.approve',
                        )
                    }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
    data: () => ({
        customer: null,
        dialog: false,
        resolve: null,
        reject: null,
        message: null,
        zIndex: 200,
        maxWidth: 700,
        btnConfirmColor: null,
        reason: null,
    }),

    validations() {
        return {
            reason: { required },
        }
    },

    mixins: [validationMixin],

    computed: {
        reasonErrors() {
            const errors = []
            if (!this.$v.reason.$dirty) return errors
            !this.$v.reason.required &&
                errors.push(
                    this.$t('forms.errors.required', {
                        label: this.$t(
                            'resources.cancellationRequisition.attributes.reason',
                        ),
                    }),
                )
            return errors
        },
    },

    methods: {
        open(customer, confirmColor) {
            this.dialog = true
            this.customer = customer
            this.btnConfirmColor = confirmColor || this.confirmColor
        },
        agree() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('forms.messages.validationError'),
                )

                return
            }

            this.customer.requestCancellation(this.reason).then(res => {
                this.dialog = false

                if (!res) {
                    return
                }

                this.$bus.$emit(
                    'notify',
                    'success',
                    'Cancelamento efetuado com sucesso!',
                )
            })

            this.$emit('modelChanged', this.customer)
            this.dialog = false
        },
        cancel() {
            this.$emit('modelChanged', this.customer)
            this.dialog = false
        },
    },

    created() {
        this.btnConfirmColor = this.confirmColor
    },
}
</script>
